// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2uKKJ","empty":"ModalGraph_empty__2J1Fe"};